export default __webpack_public_path__ + "static/media/01_male-semenacky.856b9259.jpg";